import $ from 'jquery';
import BaseAction from './base.js';
// import userMenu from './instance-builders/user-menu';
// import { headerTippyInstances, closeAllExceptThis } from './instance-builders/shared-objects';

export default class UserAction extends BaseAction {

	/**
	 * @param {JQuery} $container
	 */
	async init($container) {

		// Nothing to do here for now, the [data-drawer] attribute is explicitly set on the element so we can skip this
		// If there is any need to use a popup in the future, maybe we can uncomment this

		// User menu
		// const $userButtons = $container.find('[data-toggle-user]');

		// const $userExpanded = $container.find('[data-user-expanded]');

		// // Make sure attrs with href are not executed
		// $userButtons.on('click', function (e) { e.preventDefault(); });

		// // @ts-ignore
		// const instances = await userMenu($userButtons.get(), $userExpanded, {
		// 	onTrigger: closeAllExceptThis,
		// });

		// // Add to tippy header instances list to simulate singleton
		// instances.forEach(instance => headerTippyInstances.add(instance));
	}
}
